import React, { useEffect, useState } from 'react';
import {
  View,
  TouchableOpacity,
  TextInput,
  Image,
  StyleSheet,
  useWindowDimensions,
  ScrollView,
} from 'react-native';
import moment from 'moment';
import Text from '../../components/text';
import Feather from '@expo/vector-icons/Feather';
import Ionicons from '@expo/vector-icons/Ionicons';
import getPlatformType from '../../helpers/helpers';
import TextInputComponent from '../../components/textinput/TextInputComponent';
import Urls from '../../services/Urls';
import ajax from '../../helpers/ajaxHelper';
import DropDownPicker from '../../components/picker/DropDownPicker';
import { useRoute, useNavigation } from '@react-navigation/native';
import drawerHoc from '../../components/drawerHOC/DrawerHOC';
import DatePickerComponent from '../../components/datepicker/DatePickerComponent';
import PopUp from '../../components/popUp/PopupView';
import FilePicker from '../../components/filePicker/filepicker.web';
import { showErrorToast, showSuccesToast } from '../tenants/tenantOnboarding/helpers';
import { COLORS, BORDER_RADIUS, SHADOWS } from '../../constants/theme';

export const formatPaymentPayload = (rawState) => {
  let formattedDate = '';
  if (rawState?.date) {
    const m = moment(rawState.date);
    formattedDate = m.isValid() ? m.format('MM/DD/YYYY') : moment().format('MM/DD/YYYY');
  } else {
    formattedDate = moment().format('MM/DD/YYYY');
  }

  const payload = {
    description: rawState?.description || '',
    date: formattedDate,
    amount: String(rawState?.amount || ''),
    property_id: String(rawState?.property_id || ''),
    receipt: rawState?.receipt || [],
    is_incoming: Boolean(rawState?.is_incoming),
    is_received: Boolean(rawState?.is_received),
  };

  if (rawState?.payment_type_id) {
    payload.payment_type_id = String(rawState.payment_type_id);
  }
  if (rawState?.tenant_id) {
    payload.tenant_id = String(rawState.tenant_id);
  }
  if (rawState?.invoice_id) {
    payload.invoice_id = String(rawState.invoice_id);
  }
  if (rawState?.vat_code) {
    payload.vat_code = String(rawState.vat_code);
  }
  if (rawState?.payment_name) {
    payload.payment_name = String(rawState.payment_name);
  }
  if (rawState?.payment_status_id) {
    payload.payment_status_id = String(rawState.payment_status_id);
  }

  return payload;
};

const PaymentDetails = () => {
  const route = useRoute();
  const navigation = useNavigation();
  const { width } = useWindowDimensions();
  const isMobile = width <= 767;

  const [state, setState] = useState({
    description: '',
    date: new Date(),
    amount: '',
    property_id: '',
    receipt: [],
    invoice_id: '',
    vat_code: '',
    tenant_id: '',
    payment_name: '',
    payment_type_id: '',
    payment_status_id: '',
    is_incoming: route.name === 'PaymentIncomingDetails',
    is_received: route.name !== 'PaymentIncomingDetails',
  });

  const [paymentStatuses, setPaymentStatuses] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [properties, setProperties] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [mode, setMode] = useState('ADD');

  const dateUpdateInput = (date) => {
    setState((prev) => ({ ...prev, date }));
  };

  useEffect(() => {
    if (route?.params?.id) {
      setMode('VIEW');
      _getDetails(route?.params?.id);
    }
    if (route?.params?.type === 'EDIT') {
      setMode('EDIT');
    }

    /* Fetch Properties */
    ajax
      .get(Urls.Properties)
      .then(({ data }) => {
        if (data.status && data?.payload) {
          const temp = data.payload.map((element) => ({
            label: element.name,
            value: element.id,
          }));
          setProperties(temp);
        }
      })
      .catch((error) => console.log('error properties', error));

    /* Fetch Payment Statuses */
    ajax
      .get(Urls.PAYMENT_TYPES)
      .then(({ data }) => {
        if (data.status && data?.data?.data) {
          const temp = data.data.data.map((element) => ({
            label: element.name,
            value: element.id,
          }));
          setPaymentStatuses(temp);
        }
      })
      .catch((error) => console.log('error statuses', error));

    /* Fetch Payment Types */
    ajax
      .get(Urls.PAYMENT_TYPES_2)
      .then(({ data }) => {
        if (data.status && data?.data?.data) {
          const temp = data.data.data.map((element) => ({
            label: element.name,
            value: element.id,
          }));
          setPaymentTypes(temp);
        }
      })
      .catch((error) => console.log('error types', error));
  }, []);

  const _handleChange = (e) => {
    setState((prev) => ({ ...prev, [e.label]: e.value }));
  };

  const _getDetails = (id) => {
    ajax
      .get(Urls.Payments + '/' + id)
      .then(({ data }) => {
        if (data.status && data?.payload) {
          setState((prev) => ({
            ...prev,
            description: data?.payload?.description || '',
            date: data?.payload?.date ? new Date(data?.payload?.date) : new Date(),
            amount: data?.payload?.amount || '',
            property_id: data?.payload?.property_id || '',
            tenant_id: data?.payload?.tenant_id || '',
            receipt: data?.payload?.receipt || [],
            payment_type_id: data?.payload?.payment_type_id || '',
            payment_status_id: data?.payload?.payment_status_id || '',
          }));
        }
      })
      .catch((error) => console.log('error details', error));
  };

  const _onSave = () => {
    if (state.amount && state.date && state.description && state.property_id) {
      const payloadToSend = formatPaymentPayload(state);
      ajax
        .post(Urls.ADD_PAYMENTS, payloadToSend)
        .then(({ data }) => {
          if (data.status) {
            navigation.navigate('Payments');
          }
        })
        .catch((error) => console.log('error add payment', error));
    } else {
      showErrorToast('Please complete all required fields');
    }
  };

  const _onDelete = () => {
    ajax
      .delete(Urls.ADD_PAYMENTS + '/' + route?.params?.id)
      .then(({ data }) => {
        if (data.status) {
          setIsVisible(false);
          navigation.navigate('Payments');
        }
      })
      .catch((error) => console.log('error delete payment', error));
  };

  const _onUpdate = () => {
    const payloadToSend = formatPaymentPayload(state);
    ajax
      .put(Urls.ADD_PAYMENTS + '/' + route?.params?.id, payloadToSend)
      .then(({ data }) => {
        if (data.status) {
          navigation.navigate('Payments');
        }
      })
      .catch((error) => console.log('error update payment', error));
  };

  const isReadOnly = mode === 'VIEW';

  return (
    <ScrollView style={[styles.container, isMobile && styles.containerMobile]} showsVerticalScrollIndicator={false}>
      {/* Breadcrumb / Top Header */}
      <Text style={styles.breadcrumbText}>
        Back / {state?.is_incoming ? 'Incoming Payment' : 'Outgoing Payment'}
      </Text>

      <View style={styles.headerRow}>
        <Text style={styles.pageTitle}>
          {state?.is_incoming ? 'Incoming Payment' : 'Outgoing Payment'}
        </Text>

        {mode === 'VIEW' ? (
          <TouchableOpacity onPress={() => setMode('EDIT')} activeOpacity={0.8}>
            <Text style={styles.headerActionText}>+ Edit</Text>
          </TouchableOpacity>
        ) : (
          <TouchableOpacity onPress={() => navigation.navigate('Payments')} activeOpacity={0.8}>
            <Text style={styles.headerActionText}>+ Add</Text>
          </TouchableOpacity>
        )}
      </View>

      {/* Main White Card Container matching Figma */}
      <View style={[styles.cardContainer, isMobile && styles.cardContainerMobile]}>
        <Text style={styles.sectionTitle}>Payment Description</Text>

        {/* Invoice ID / Payment Description */}
        <View style={styles.fieldGroup}>
          <TextInputComponent
            title="Payment Description*"
            placeholder="Enter description..."
            value={state?.description}
            onChangeText={(val) => _handleChange({ value: val, label: 'description' })}
            height={44}
            disabled={isReadOnly}
            error={state?.description ? false : '*Required'}
          />
        </View>

        {/* Amount (£) + Date Row */}
        <View style={[styles.rowGrid, isMobile && styles.rowGridMobile]}>
          <View style={[styles.colGrid, isMobile && styles.colGridMobile]}>
            <TextInputComponent
              title="Amount (£)*"
              placeholder="e.g. 1200"
              value={state?.amount?.toString()}
              keyboardType="numeric"
              onChangeText={(val) => _handleChange({ value: val, label: 'amount' })}
              height={44}
              disabled={isReadOnly}
              isAmount
              error={state?.amount ? false : '*Required'}
            />
          </View>

          <View style={[styles.colGrid, isMobile && styles.colGridMobile]}>
            <TextInputComponent
              title="Date*"
              placeholder="dd/mm/yyyy"
              isDate
              date={state?.date}
              onChangeText={dateUpdateInput}
              disabled={isReadOnly}
              height={44}
              error={state?.date ? false : '*Required'}
            />
          </View>
        </View>

        {/* Property + Tenant / Contractor Row */}
        <View style={[styles.rowGrid, isMobile && styles.rowGridMobile]}>
          <View style={[styles.colGrid, isMobile && styles.colGridMobile]}>
            <DropDownPicker
              items={properties}
              title="Property*"
              placeholder="Select Property"
              defaultValue={state?.property_id}
              onChangeItem={(e) => _handleChange({ value: e.value, label: 'property_id' })}
              disabled={isReadOnly}
              error={state?.property_id ? false : '*Required'}
            />
          </View>

          <View style={[styles.colGrid, isMobile && styles.colGridMobile]}>
            <DropDownPicker
              items={[]}
              title="Tenant"
              placeholder="Select Tenant"
              defaultValue={state?.tenant_id}
              onChangeItem={(e) => _handleChange({ value: e.value, label: 'tenant_id' })}
              disabled={isReadOnly}
            />
          </View>
        </View>

        {/* Payment Type + Payment Status Row */}
        <View style={[styles.rowGrid, isMobile && styles.rowGridMobile]}>
          <View style={[styles.colGrid, isMobile && styles.colGridMobile]}>
            <DropDownPicker
              items={paymentTypes}
              title="Payment Type*"
              placeholder="Select Payment Type"
              defaultValue={state?.payment_type_id}
              onChangeItem={(e) => _handleChange({ value: e?.value, label: 'payment_type_id' })}
              disabled={isReadOnly}
              error={state?.payment_type_id ? false : '*Required'}
            />
          </View>

          {state?.is_incoming && (
            <View style={[styles.colGrid, isMobile && styles.colGridMobile]}>
              <DropDownPicker
                items={paymentStatuses}
                title="Payment Made / Status"
                placeholder="Select Status"
                defaultValue={state?.payment_status_id}
                onChangeItem={(e) => _handleChange({ value: e.value, label: 'payment_status_id' })}
                disabled={isReadOnly}
              />
            </View>
          )}
        </View>

        {/* Attach Documents Dropzone */}
        <View style={{ marginTop: 16 }}>
          <Text style={styles.attachTitle}>Attach Documents</Text>

          {!isReadOnly && (
            <FilePicker
              style={{ width: '100%' }}
              onDataSuccess={(value) =>
                _handleChange({ value: [...(state.receipt || []), ...value], label: 'receipt' })
              }
            />
          )}

          {state?.receipt && state?.receipt.length > 0 && (
            <View style={{ marginTop: 12 }}>
              {state.receipt.map((item, index) => (
                <View key={index} style={styles.receiptRow}>
                  <View style={{ flexDirection: 'row', alignItems: 'center', flex: 1, gap: 8 }}>
                    <Ionicons name="document-attach-outline" size={18} color="#6C2BD9" />
                    <TouchableOpacity onPress={() => window.open(item.openbrixName, '_blank')}>
                      <Text style={styles.receiptName} numberOfLines={1}>
                        {item?.name || `Document ${index + 1}`}
                      </Text>
                    </TouchableOpacity>
                  </View>

                  {!isReadOnly && (
                    <TouchableOpacity
                      onPress={() => {
                        const tempArr = [...state.receipt];
                        tempArr.splice(index, 1);
                        setState((prev) => ({ ...prev, receipt: tempArr }));
                      }}
                    >
                      <Text style={styles.removeText}>Remove</Text>
                    </TouchableOpacity>
                  )}
                </View>
              ))}
            </View>
          )}
        </View>

        {/* Footer Action Buttons matching Figma */}
        <View style={styles.footerRow}>
          <TouchableOpacity
            style={styles.backBtn}
            onPress={() => navigation.navigate('Payments')}
            activeOpacity={0.8}
          >
            <Text style={styles.backBtnText}>Back</Text>
          </TouchableOpacity>

          {mode === 'ADD' && (
            <TouchableOpacity style={styles.confirmBtn} onPress={_onSave} activeOpacity={0.85}>
              <Text style={styles.confirmBtnText}>Confirm</Text>
            </TouchableOpacity>
          )}

          {mode === 'EDIT' && (
            <View style={{ flexDirection: 'row', gap: 10 }}>
              <TouchableOpacity
                style={styles.deleteBtn}
                onPress={() => setIsVisible(true)}
                activeOpacity={0.8}
              >
                <Text style={styles.deleteBtnText}>Delete</Text>
              </TouchableOpacity>
              <TouchableOpacity style={styles.confirmBtn} onPress={_onUpdate} activeOpacity={0.85}>
                <Text style={styles.confirmBtnText}>Save Changes</Text>
              </TouchableOpacity>
            </View>
          )}

          {mode === 'VIEW' && (
            <TouchableOpacity
              style={styles.deleteBtn}
              onPress={() => setIsVisible(true)}
              activeOpacity={0.8}
            >
              <Text style={styles.deleteBtnText}>Delete</Text>
            </TouchableOpacity>
          )}
        </View>
      </View>

      {/* Delete Confirmation Popup */}
      <PopUp
        modalVisible={isVisible}
        titleText="Delete Payment?"
        titleColor="#6C2BD9"
        subTitleText="Are you sure you want to delete this payment?"
        subTitleColor="black"
        actionButtons={[
          {
            text: 'Delete',
            width: 100,
            onPress: _onDelete,
          },
          {
            text: 'Cancel',
            width: 100,
            onPress: () => setIsVisible(false),
          },
        ]}
        closePopup={() => setIsVisible(false)}
      />
    </ScrollView>
  );
};

export default drawerHoc({
  Component: PaymentDetails,
  title: 'PaymentDetails',
  showBackButton: true,
});

/* ================= STYLES ================= */

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    backgroundColor: COLORS.appBg,
  },
  containerMobile: {
    padding: 14,
  },

  breadcrumbText: {
    fontSize: 12,
    color: '#9CA3AF',
    marginBottom: 6,
  },

  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 20,
  },

  pageTitle: {
    fontSize: 22,
    fontWeight: '700',
    color: COLORS.textPrimary,
  },

  headerActionText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#EF4444',
  },

  /* MAIN WHITE CARD CONTAINER */
  cardContainer: {
    backgroundColor: COLORS.surface,
    borderRadius: BORDER_RADIUS.lg,
    borderWidth: 1,
    borderColor: COLORS.border,
    padding: 24,
    marginBottom: 40,
    ...SHADOWS.sm,
  },
  cardContainerMobile: {
    padding: 16,
    borderRadius: BORDER_RADIUS.md,
  },

  sectionTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: COLORS.textPrimary,
    marginBottom: 16,
  },

  fieldGroup: {
    marginBottom: 16,
  },

  rowGrid: {
    flexDirection: 'row',
    gap: 16,
    marginBottom: 16,
  },
  rowGridMobile: {
    flexDirection: 'column',
    gap: 12,
  },

  colGrid: {
    flex: 1,
  },
  colGridMobile: {
    width: '100%',
  },

  attachTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#374151',
    marginBottom: 8,
  },

  receiptRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#F9FAFB',
    borderRadius: 8,
    padding: 12,
    marginBottom: 8,
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  receiptName: {
    fontSize: 13,
    fontWeight: '600',
    color: '#6C2BD9',
  },
  removeText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#EF4444',
  },

  /* FOOTER ACTION BUTTONS (matching Figma) */
  footerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 24,
    paddingTop: 16,
    borderTopWidth: 1,
    borderColor: '#F3F4F6',
  },

  backBtn: {
    backgroundColor: '#F3F4F6',
    borderRadius: BORDER_RADIUS.md,
    paddingHorizontal: 20,
    paddingVertical: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  backBtnText: {
    fontSize: 13,
    fontWeight: '600',
    color: '#374151',
  },

  confirmBtn: {
    backgroundColor: '#6C2BD9',
    borderRadius: BORDER_RADIUS.md,
    paddingHorizontal: 24,
    paddingVertical: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  confirmBtnText: {
    fontSize: 13,
    fontWeight: '700',
    color: '#FFFFFF',
  },

  deleteBtn: {
    backgroundColor: '#FEE2E2',
    borderRadius: BORDER_RADIUS.md,
    paddingHorizontal: 18,
    paddingVertical: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  deleteBtnText: {
    fontSize: 13,
    fontWeight: '600',
    color: '#DC2626',
  },
});
